import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, delay, Subject, take, throwError, timeout, TimeoutError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BookmarkService {

    constructor(private http: HttpClient) { }

    $bookmarks = new BehaviorSubject<any[]>([]);
    $bookmarksOpen = new BehaviorSubject<boolean>(false);
    $refreshBookmarks = new Subject<void>();
    $bookmarkError = new Subject<boolean>();
    $bookmarkFilter = new BehaviorSubject<string>('');

    private stripAccountId<T>(body: T): T {
        if (body && typeof body === 'object') {
            const { accountId, ...rest } = body as Record<string, unknown>;
            return rest as T;
        }

        return body;
    }
    

    getBookmarks(accountId: string) {
        return this.http.get(window.location.protocol + "//" + window.location.hostname + (window.location.port !== "" ? ":" + "8080" : "") + "/data/getBookmarks").pipe(
                     timeout(30000), catchError(error => {
                       if (error instanceof TimeoutError) {
                           console.error('Request timed out after 30s');
                       }
                       return throwError(() => error);
                   }))  
    }

    getBookmark(body: any) {
        return this.http.put(window.location.protocol + "//" + window.location.hostname + (window.location.port !== "" ? ":" + "8080" : "") + "/data/getBookmark", this.stripAccountId(body)).pipe(
                     timeout(30000), catchError(error => {
                       if (error instanceof TimeoutError) {
                           console.error('Request timed out after 30s');
                       }
                       return throwError(() => error);
                   }))
    }

    getBookmarkSite(body: any) {
        return this.http.put(window.location.protocol + "//" + window.location.hostname + (window.location.port !== "" ? ":" + "8080" : "") + "/data/getBookmarkSite", this.stripAccountId(body)).pipe(
                     timeout(30000), catchError(error => {
                       if (error instanceof TimeoutError) {
                           console.error('Request timed out after 30s');
                       }
                       return throwError(() => error);
                   }))
    }

    updateBookmark(body: any) {
        return this.http.put(window.location.protocol + "//" + window.location.hostname + (window.location.port !== "" ? ":" + "8080" : "") + "/data/updateBookmark", this.stripAccountId(body)).pipe(
                       timeout(30000), catchError(error => {
                       if (error instanceof TimeoutError) {
                           console.error('Request timed out after 30s');
                       }
                       return throwError(() => error);
                   }))
    }

    updateBookmarkSite(body: any) {
        return this.http.put(window.location.protocol + "//" + window.location.hostname + (window.location.port !== "" ? ":" + "8080" : "") + "/data/updateBookmarkSite", this.stripAccountId(body)).pipe(
                       timeout(30000), catchError(error => {
                       if (error instanceof TimeoutError) {
                           console.error('Request timed out after 30s');
                       }
                       return throwError(() => error);
                   }))
    }

    deleteBookmark(body: any) {
        return this.http.put(window.location.protocol + "//" + window.location.hostname + (window.location.port !== "" ? ":" + "8080" : "") + "/data/deleteBookmark", this.stripAccountId(body)).pipe(
                     timeout(30000), catchError(error => {
                       if (error instanceof TimeoutError) {
                           console.error('Request timed out after 30s');
                       }
                       return throwError(() => error);
                   }))
    }

    deleteBookmarkSite(body: any) {
        return this.http.put(window.location.protocol + "//" + window.location.hostname + (window.location.port !== "" ? ":" + "8080" : "") + "/data/deleteBookmarkSite", this.stripAccountId(body)).pipe(
                     timeout(30000), catchError(error => {
                       if (error instanceof TimeoutError) {
                           console.error('Request timed out after 30s');
                       }
                       return throwError(() => error);
                   }))
    }


}